module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"404":"お探しのページは見つかりませんでした。","error":"エラーが発生しました","bth":"トップページへ戻る"},"en":{"404":"This page could not found.","error":"An error occured","bth":"Back to the home page"}}')
  delete Component.options._Ctor
}
